import { Carousel } from "react-responsive-carousel";
import styles from "./Testimonials.module.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {useState} from "react";
import { useTranslation } from "react-i18next";

export const Testimonials = () => {
    const [expanded, setExpanded] = useState<Record<number, boolean>>({});
    const { t } = useTranslation();

    const testimonials = t("home.testimonials", { returnObjects: true });
    const toggle = (index: number) => {
        setExpanded(prev => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    return (
        <div>
            <h2>{t("home.testimonialsTitle")}</h2>

            <Carousel
                className={styles.carousel}
                showStatus={false}
                showIndicators={false}
                infiniteLoop
                useKeyboardArrows
                swipeable
                emulateTouch
            >
                {testimonials.map((testimonial, i) => {
                    const isExpanded = expanded[i];

                    return (
                        <div key={i} className={styles.slide}>
                            <div className={styles.card}>
                                <div className={styles.left}>
                                    <span className={styles.date}>{testimonial.date}</span>
                                    <div>
                                        <h3>{testimonial.title}</h3>
                                        <span className={styles.location}>
                      {testimonial.location}
                    </span>
                                    </div>
                                </div>

                                <div className={styles.right}>
                                    <p className={styles.title}>{testimonial.subTitle}</p>

                                    <div
                                        className={`${styles.text} ${
                                            !isExpanded ? styles.collapsed : ""
                                        }`}
                                    >
                                        {testimonial.text.map((str, idx) => (
                                            <span key={idx}>{str}</span>
                                        ))}
                                    </div>

                                    <button
                                        className={styles.toggle}
                                        onClick={() => toggle(i)}
                                    >
                                        {isExpanded ? t("home.testimonialsHide") : t("home.testimonialsShowFull")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Carousel>
        </div>)
};
